'use client';

import clsx from 'clsx';
import { FC, useState } from 'react';
import { Body } from 'atoms/Typography/Typography';
import { Modal } from 'molecules/Modal';
import { ReturnGo } from 'organisms/Orders/ReturnGo';
import {
  addReturGoUrlParams,
  deleteReturGoUrlParams,
} from 'organisms/Orders/ReturnGo/utils';
import { useUser } from 'modules/shop/user/hooks';
import styles from './styles.module.css';

export const ReturnOrderButton: FC<{
  text?: string;
  className?: string;
}> = ({ text, className }) => {
  const { user } = useUser();
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    if (user?.email) {
      addReturGoUrlParams(user.email);
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    deleteReturGoUrlParams({ email: !!user });
  };

  return !text ? null : (
    <>
      <button
        className={clsx(styles.button, className)}
        onClick={handleOpenModal}
      >
        <Body type="md" tag="span">
          {text}
        </Body>
      </button>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        classes={{ container: styles.modalContainer }}
      >
        <ReturnGo />
      </Modal>
    </>
  );
};
